// Version : 0.0.1
// Author : SATHISH
// LastEdit : SHIYAM
// MODFIED DATE: 06-10-2025
// Last ADD : changed backend entity name into small alphabets

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';
/************** GET PRECLOSE REPORT LIST START ************************** */
export const precloseReportListGet = (listData: any) => {
	const data = {
		GetMemberPreCloseToken: listData,
	};
	const url = `${API_URL}getMemberPreClosedLoanDetails`;
	return makeApiCall(url, data);
};
/************** GET PRECLOSE REPORT LIST END ************************** */
